import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent implements OnInit {
  @Input('value') public value: string;
  @Input('status') public status: TagStatus = 'basic';

  constructor() {}

  ngOnInit(): void {
  }

}

export declare type TagStatus = 'basic' | 'primary' | 'danger' | 'warning' | 'info' | 'success';
